import qs from 'qs';

import {
  displaySearchConditions,
  showSearchConditionsMiniContainer,
  hideSearchConditionsMiniContainer,
} from './search_conditions_mini';
import {
  getSearchParams,
  validateSearchParams,
  DEFAULT_ADULTS,
  DEFAULT_CHILDREN,
  countAdults,
  countChildren,
  getTranslatedAdult,
  getTranslatedChild,
  getTranslatedChildAge,
} from '../helper/accommodation_helper';

const ROOM_MAX = 4;
const SWITCH_MODAL_WIDTH = 991;

export function setupSearchForm(onClickSearchButton?: Function) {
  const $ = (window as any).jQuery;
  const history = (window as any).history;

  if ($('#accommodations-search-form').length === 0) return;

  $('#js-accommodation-search-button').click(() => {
    const form = $('#accommodations-search-form');
    const query = form.serialize();
    const lastSegmentOfUrl = location.pathname.substr(location.pathname.lastIndexOf('/') + 1)
    history.replaceState('', '', `${lastSegmentOfUrl}?${query}`)

    $('#accommodations-search-form-modal').modal('hide');
    displaySearchConditions(getSearchParams());
    
    if (typeof onClickSearchButton === 'function') {
      onClickSearchButton();
    }
  });

  $('#person_modal').on('hidden.bs.modal', () => {
    const form = $('#accommodations-search-form');
    const paramsString = form.serialize();
    const params = qs.parse(paramsString);
    displayPeopleCount(params);
  });

  $(window).on('resize orientationchange', () => {
    switchModalByWindowWidth();
  });
  
  let searchParams = getSearchParams();

  if (!validateSearchParams(searchParams)) {
    return;
  }
  switchModalByWindowWidth();
  initSearchForm(searchParams);
  // indexRoomNumber(); 複数部屋検索ができるようになるまでコメントアウト
  
  displaySearchConditions(searchParams);
  displayPeopleCount(searchParams);

  $('#js-add-room').click(function () {
    addRoom();
  });

  $('.children').change(function () {
    let childCount = parseInt($(this).val());
    addChildAges($(this), childCount);
  });

  $('.remove-room').click(function () {
    $(this).parent().parent().parent().remove();
    indexRoomNumber();
  });
}


function switchModalByWindowWidth() {
  const $ = (window as any).jQuery;

  const winWidth = (window as any).innerWidth;
  if (winWidth <= SWITCH_MODAL_WIDTH) {
    $('#accommodations-search-form').insertAfter($('#accommodations-search-form-insert-modal'));
    showSearchConditionsMiniContainer();
    hideSearchFormCard();
  } else {
    $('#accommodations-search-form-modal').modal('hide');
    $('#accommodations-search-form').insertAfter($('#accommodations-search-form-insert-default'));
    hideSearchConditionsMiniContainer();
    showSearchFormCard();
  }
}

function initSearchForm(searchParams) {
  const $ = (window as any).jQuery;

  if (searchParams) {
    if (searchParams.rooms && searchParams.rooms.length >= 1) {
      searchParams.rooms.forEach((room, index) => {
        if (index >= 1) {
          addRoom();
        }
        $('#room' + (index + 1)).find('.adults').val(room.adults);
        let childrenElem = $('#room' + (index + 1)).find('.children');
        childrenElem.val(room.children || 0);
        let childCount = parseInt(room.children);
        if (childCount >= 1) {
          if (room.child_ages && room.child_ages.length >= 1) {
            addChildAges(childrenElem, childCount, room.child_ages);
          } else {
            addChildAges(childrenElem, childCount);
          }
        }
      });
    }
    if (!searchParams.rooms) { // 部屋1の大人の人数の初期値は2にセット
      $('#room1').find('.adults').val(DEFAULT_ADULTS);
    }
  }
  $('#accommodations-search-form').show();
}

export function getFormParams() {
  const $ = (window as any).jQuery;

  const form = $('#accommodations-search-form');
  const paramsString = form.serialize();
  const params = qs.parse(paramsString);
  return params;
}

function addChildAges(childrenElem: any, childCount: number, childAgesOpt?: Array<number>) {
  const $ = (window as any).jQuery;
  const $ageItem = childrenElem.parent().find('.child-age');
  const $container = childrenElem.parent().find('.child-ages');

  $ageItem.each((index, elem) => {
    if (index != 0 && index >= childCount) {
      elem.remove();
    }
  });
  if (childCount === 0) {
    $container.hide();
    $container.find('select').prop('disabled', true);
  } else {
    $container.show();
    $container.find('select').prop('disabled', false);
  }

  const currentChildAgesLength = childrenElem.parent().find('.child-ages').children().length;
  for (let i = 1; i <= childCount; i++) {
    if (i <= currentChildAgesLength) {
      const childAgeElem = childrenElem.parent().find('.child-age').eq(i - 1);
      if (childAgesOpt && childAgesOpt.length >= 1) {
        childAgeElem.find('.child-age-select').val(childAgesOpt[i - 1]);
      }
    }

    if (i > currentChildAgesLength) { // 足りない.child-age要素を追加
      const childAgeElem = childrenElem.parent().find('.child-age').first().clone(true);

      const translatedChildAge = getTranslatedChildAge(i);
      childAgeElem.find('.child-age-label').text(translatedChildAge);

      childAgeElem.appendTo(childrenElem.parent().find('.child-ages'));

      if (childAgesOpt && childAgesOpt.length >= 1) {
        childAgeElem.find('.child-age-select').val(childAgesOpt[i - 1]);
      }
    }
  }
}

function addRoom() {
  const $ = (window as any).jQuery;

  const roomsCount = $('#rooms').children().length;
  const roomNextNum = roomsCount + 1;
  if (roomsCount < ROOM_MAX) {
    const roomElem = $('#room1').clone(true);
    setRoomId(roomElem, roomNextNum);
    setRoomDisplayNumber(roomElem, roomNextNum);
    setRoomFormIndex(roomElem, (roomNextNum - 1));
    roomElem.find('.child-ages').hide();
    roomElem.appendTo($('#rooms'));
    roomElem.find('.remove-room').show();
  }
  showHideAddRoomButton();
}

function indexRoomNumber() {
  const $ = (window as any).jQuery;

  $('#rooms').children().each((index, elem) => {
    const roomElem = $(elem);
    setRoomId(roomElem, (index + 1));
    setRoomDisplayNumber(roomElem, (index + 1));
    setRoomFormIndex(roomElem, index);
    if (index === 0) {
      $(elem).find('.remove-room').hide();
    } else {
      $(elem).find('.remove-room').show();
    }
  });
  showHideAddRoomButton();
}

function setRoomId(roomElem, number) {
  roomElem.attr('id', 'room' + number);
}

function setRoomDisplayNumber(roomElem, number) {
  const translatedRoom = getTranslatedRoom();

  roomElem.find('.room-number').text(translatedRoom + number);
}

function setRoomFormIndex(roomElem, index) {
  roomElem.find('.adults').attr('name', `rooms[${index}][adults]`);
  roomElem.find('.children').attr('name', `rooms[${index}][children]`);
  roomElem.find('.child-age-select').attr('name', `rooms[${index}][child_ages][]`);
}

function getTranslatedRoom() {
  const $ = (window as any).jQuery;

  const translatedRoom = $('#js-search-form-t-room').attr('data-t-room'); // 部屋の翻訳
  return translatedRoom;
}

function showHideAddRoomButton() {
  const $ = (window as any).jQuery;

  if ($('#rooms').children().length >= ROOM_MAX) {
    $('#js-add-room').hide();
  } else {
    $('#js-add-room').show();
  }
}

function hideSearchFormCard() {
  const $ = (window as any).jQuery;
  $('#search-form-card').hide();
}

function showSearchFormCard() {
  const $ = (window as any).jQuery;
  $('#search-form-card').show();
}

function displayPeopleCount(params) {
  const $ = (window as any).jQuery;
  const adultLabel = getTranslatedAdult();
  const childLabel = getTranslatedChild();

  if (params.rooms) {
    const displayPeopleCountString = `${adultLabel} ${countAdults(params.rooms)} / ${childLabel} ${countChildren(params.rooms)}`
    $('#js-open-people-input').val(displayPeopleCountString);
  } else {
    const displayPeopleCountString = `${adultLabel} ${DEFAULT_ADULTS} / ${childLabel} ${DEFAULT_CHILDREN}`
    $('#js-open-people-input').val(displayPeopleCountString);
  }
}
